import moment from 'moment';

export const formatDateTime = (date) =>
  date && moment(date).isValid() ? moment(date).format('DD/MM/YYYY HH:mm') : '';

export const isAfter = (dateToCheck, comparisonDate) => {
  return (
    dateToCheck && moment(dateToCheck).isSameOrAfter(moment(comparisonDate))
  );
};

export const getPastYears = (numberOfYears) => {
  const years = [];
  for (let i = 0; i <= numberOfYears; i++) {
    years.push(moment().subtract(i, 'years').year());
  }
  return years;
};

export const getLastDateOfCurrentYear = () => {
  return moment().endOf('year');
};

export const getMonthsUntilYearEnd = (date) => {
  const endDateOfYear = moment(date).endOf('year');
  const diffInMonths = endDateOfYear.diff(date, 'months', true);
  return Math.ceil(diffInMonths);
};
